import { useState } from 'react';
import { userInfoSync } from 'hub-http/userInfo';
import styled from 'styled-components';
import { rgba } from 'foundations-components/transitional/utils/color';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIButton from 'UIComponents/button/UIButton';
import UIDropdownCaret from 'UIComponents/dropdown/UIDropdownCaret';
import { getEncodedValue, getDecodedContent, openPersonalizePopover } from 'tinymce-config/utils/handlers';
import { getConfig } from 'tinymce-config/configs/editors/personalization-field';
// @ts-expect-error untyped module react-tinymce
import TinyMCE from 'react-tinymce';
import { CONTACT_FQN } from 'rich-text-lib/constants/properties';
import Routes from 'ContentUtils/Routes';
import EditFormControl from 'ContentComponents/cmv2/EditFormControl';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const KEY = 'HS_EMAIL_EDITOR_SUBJECT_FIELD';
const i18nKey = key => `ContentComponents.cmv2.fields.form.formWorkflowDependencies.followupEmailWorkflows.emailEditorPanel.subject.${key}`;
const RichTextEditorWrapper = styled.div.withConfig({
  displayName: "SubjectField__RichTextEditorWrapper",
  componentId: "lptt66-0"
})(({
  theme
}) => {
  const focusColor = theme.color['border-interactive-default'];
  return {
    '.mce-content-body:focus': {
      borderColor: rgba(focusColor, 1.0),
      boxShadow: `0 0 4px 1px ${rgba(focusColor, 0.8)}, 0 0 0 1px ${focusColor}`,
      outline: 0
    }
  };
});
const SubjectField = ({
  onChange,
  pickerComponents,
  value
}) => {
  const [config, setConfig] = useState();
  const [editor, setEditor] = useState();
  const {
    user
  } = userInfoSync();
  const _getConfig = () => {
    if (config) return config;
    const _config = getConfig({
      appName: 'page-editor',
      gates: Routes.gates,
      scopes: user.scopes,
      includeSiteSettings: false,
      includeSubscriptionType: false,
      pickerComponents,
      supportedCrmObjectFQNs: [CONTACT_FQN],
      isMultiline: true
    });
    setConfig(_config);
    return _config;
  };
  return /*#__PURE__*/_jsx(EditFormControl, {
    "data-field-key": "subject" // needed to ensure the label is full-width so that labelItemRight is all the way to the right
    ,
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: i18nKey('label')
    }),
    labelItemRight: /*#__PURE__*/_jsxs(UIButton, {
      use: "transparent",
      className: "p-all-0",
      onClick: () => {
        if (editor) {
          openPersonalizePopover(editor);
        }
      },
      children: [/*#__PURE__*/_jsx(UIIcon, {
        name: "contacts"
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey('contactToken')
      }), /*#__PURE__*/_jsx(UIDropdownCaret, {
        className: "m-left-1"
      })]
    }),
    required: true,
    children: /*#__PURE__*/_jsx(RichTextEditorWrapper, {
      children: /*#__PURE__*/_jsx(TinyMCE, {
        config: _getConfig(),
        uniqueKey: KEY,
        tinyMceRef: ({
          editor: _editor
        }) => setEditor(_editor),
        content: getEncodedValue(value || ''),
        onChange: (e, _editor) => {
          onChange(getDecodedContent(_editor));
        }
      })
    })
  });
};
export default SubjectField;